import React from 'react'
import resolveProps from '../../utils/resolveProps'
import { AlertProps } from './types'

const config = {
  types: ['success', 'danger'],
  modifiers: ['light', 'dark']
}

export default function Alert(props: AlertProps ) {
  const {
    children,
    isOpen = true,
    success = false,
    danger = false,
    light = false,
    dark = false,
    onClick = (e:React.MouseEventHandler)=>{}
  } = props

  const [state, setState] = React.useState(isOpen )

  React.useEffect(() => {
    setState(isOpen)

  }, [isOpen])

  const handleClick = (e) => {
    // do something...
    return onClick && onClick(e)
  }

  return (
    <div
      className={`${resolveProps(props, config, 'Alert')}
      ${state ? 'mdn-isOpen' : ''}`}
      aria-hidden={state ? 'false' : 'true'}
      tabIndex={0}
    >
      <div className="mdn-Alert-content">
        <p className="mdn-Text mdn-Text--body">{children}</p>
      </div>
      <button
        role="button"
        type='button'
        className="mdn-Alert-close mdn-Button mdn-Button--icon mdn-Button--secondary"
        onClick={(e) => handleClick(e)}
        aria-label="Button close alert"
      >
        <span className="mdn-Icon-fechar mdn-Icon--sm"></span>
      </button>
    </div>
  )
}
